<template>
  <div class="hero-text-placeholder">
    <content-loader
      class="d-none d-lg-block"
      primary-color="#ffffff"
      secondary-color="#cccccc"
      :primary-opacity="0.6"
      :secondary-opacity="0.5"
      width="278"
      height="410"
      viewBox="0 0 278 410"
    >
      <rect x="0" y="0" rx="0" ry="0" width="270" height="42" />
      <rect x="0" y="50" rx="0" ry="0" width="250" height="42" />
      <rect x="0" y="100" rx="0" ry="0" width="270" height="42" />
      <rect x="0" y="150" rx="0" ry="0" width="139" height="42" />
      <rect x="0" y="208" rx="0" ry="0" width="270" height="15" />
      <rect x="0" y="227" rx="0" ry="0" width="270" height="15" />
      <rect x="0" y="246" rx="0" ry="0" width="270" height="15" />
      <rect x="0" y="265" rx="0" ry="0" width="270" height="15" />
      <rect x="0" y="284" rx="0" ry="0" width="106" height="15" />
      <rect x="46" y="330" rx="30" ry="30" width="175" height="58" />
    </content-loader>
    <content-loader
      class="mt-5 d-lg-none"
      primary-color="#ffffff"
      secondary-color="#cccccc"
      :primary-opacity="0.6"
      :secondary-opacity="0.5"
      :width="width"
      :height="totalHeight"
    >
      <rect
        v-for="hr in headingRows"
        :key="hr + 100"
        :x="gap"
        :y="getHeadingRowPosition(hr)"
        :width="getRowWidth(hr === headingRows, 0.25)"
        :height="headingRowHeight"
      />

      <rect
        v-for="tr in textRows"
        :key="tr + 200"
        :x="gap"
        :y="getTextRowPosition(tr)"
        :width="getRowWidth(tr === textRows, 0.75)"
        :height="textRowHeight"
      />

      <rect :x="width / 2 - buttonWidth / 2" :y="headingHeight + textHeight" rx="30" ry="30" :width="buttonWidth" :height="buttonHeight" />
    </content-loader>
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { ContentLoader } from "vue-content-loader";

defineOptions({
  name: "hero-text-placeholder",
});

const width = ref(window.innerWidth);
const gap = ref(16);
const headingRows = ref(2);
const headingRowHeight = ref(38);
const headingGap = ref(6);
const headingBottomGap = ref(24);
const textRows = ref(3);
const textRowHeight = ref(15);
const textGap = ref(4);
const textBottomGap = ref(24);
const buttonHeight = ref(58);

const buttonWidth = computed(() => {
  return width.value > 300 + gap.value * 2 ? 300 : width.value - gap.value * 2;
});

const headingHeight = computed(() => {
  return (headingRowHeight.value + headingGap.value) * headingRows.value + headingBottomGap.value;
});

const textHeight = computed(() => {
  return (textRowHeight.value + textGap.value) * textRows.value + textBottomGap.value;
});

const totalHeight = computed(() => {
  return headingHeight.value + textHeight.value + buttonHeight.value;
});

const getHeadingRowPosition = (index: number) => {
  return (index - 1) * (headingGap.value + headingRowHeight.value);
};

const getTextRowPosition = (index: number) => {
  return headingHeight.value + (index - 1) * (textGap.value + textRowHeight.value);
};

const getRowWidth = (isLast: boolean, length: number = 1) => {
  const widthValue = width.value - gap.value * 2;
  return isLast ? widthValue * length : widthValue;
};

const onResize = () => {
  width.value = window.innerWidth;
};

onMounted(() => {
  window.addEventListener("resize", onResize);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", onResize);
});
</script>
